import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Providers } from './components';
import { App } from './app';
import './styles/globals.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <Providers>
      <App />
    </Providers>
  </StrictMode>
);
